export const AUTH_TOKEN_KEY = 'popsizeToken';

export const MENSWEAR_SHOPPING_PREFERENCE = '1';
export const WOMENSWEAR_SHOPPING_PREFERENCE = '2';

export const MENSWEAR_SHOPPING_PREFERENCE_STRING = 'male';
export const WOMENSWEAR_SHOPPING_PREFERENCE_STRING = 'female';


export const MAX_BRAND_SELECTION = 3;

export const DEFAULT_TYPE_LABEL_LONG_CODE = '71957756';
